import { Link } from 'react-router-dom';
import { animeSeries } from '@/mocks/anime';

const steps = [
  { icon: 'ri-clapperboard-line', title: '按话拆解', desc: '把整部番按话整理成独立的分集简介，每一话讲了什么都一目了然。' },
  { icon: 'ri-list-check-3', title: '剧情梳理', desc: '把零散剧情归纳成清晰的故事线阶段，帮你快速掌握主线走向与关键转折。' },
  { icon: 'ri-chat-smile-3-line', title: '解说引导', desc: '补充必要的背景与伏笔解读，让补番和回顾时不再看得一头雾水。' },
];

export default function StorylineFeature() {
  const featured = animeSeries[2]; // 苍澜剑影

  return (
    <section id="storyline" className="mx-auto max-w-7xl scroll-mt-16 px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
        {/* method */}
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-primary-600">
            <i className="ri-list-unordered" /> 剧情梳理
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            一部番怎么快速看懂？
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
            我们不为剧透而剧透，而是把复杂的叙事拆成可快速消化的片段。你不需要一口气追完全部，也能通过分集简介与故事线梳理，掌握「现在讲到哪」「接下来会怎样」。
          </p>
          <div className="mt-6 space-y-4">
            {steps.map((s, i) => (
              <div key={s.title} className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-600">
                  <i className={s.icon} />
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">
                    <span className="mr-2 text-primary-500">{i + 1}.</span>
                    {s.title}
                  </p>
                  <p className="mt-1 text-sm leading-6 text-foreground-700">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* featured storyline timeline */}
        <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
          <div className="flex items-center justify-between">
            <h3 className="font-heading text-lg font-bold text-foreground-950">{featured.title} · 故事线梳理</h3>
            <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-800">示例</span>
          </div>
          <p className="mt-2 text-sm text-foreground-700">{featured.tagline}</p>
          <ol className="relative mt-6 space-y-6 border-l-2 border-background-200 pl-6">
            {featured.storyline.map((point, i) => (
              <li key={i} className="relative">
                <span
                  className={`absolute -left-[31px] flex h-4 w-4 items-center justify-center rounded-full ring-4 ring-background-50 ${
                    i === 0 ? 'bg-primary-500' : 'bg-accent-400'
                  }`}
                />
                <p className="text-sm font-semibold text-foreground-900">第 {i + 1} 幕</p>
                <p className="mt-1 text-sm leading-6 text-foreground-700">{point}</p>
              </li>
            ))}
          </ol>
          <Link
            to={`/anime/${featured.slug}`}
            className="mt-6 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            查看 {featured.title} 全部分集 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}